import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';


import { MENU_TOGGLE_STATE_LANGUAGE } from './global-navigation.constant';

@Component({
  selector: 'app-global-navigation',
  templateUrl: './global-navigation.component.html',
  styleUrls: ['./global-navigation.components.scss']
})
export class GlobalNavigationComponent implements OnInit {

  public menuToggleStateLabelEnglish = MENU_TOGGLE_STATE_LANGUAGE.english;
  public currentRoute: any;
  public menuExpandCollapse: boolean = true;
  public menuList: { menuTitle: string, routerLink: string, menuSubTitle?: string, menuIndicator?: number | string, isDisable?: boolean, cssClass: string[] }[] = [
    { menuTitle: 'Dashboard', routerLink: '/dashboard', cssClass: ['icon-lms-dashboard', 'icon-lms-dashboard-fill'] },
    { menuTitle: 'Courses', routerLink: '/courses', menuSubTitle: 'Gateway A1+', cssClass: ['icon-course', 'icon-course-full'] },
    { menuTitle: 'Classes', routerLink: '/classes', cssClass: ['icon-my-classes', 'icon-my-classes-full'] },
    { menuTitle: 'Calendar', routerLink: '/calendar', cssClass: ['icon-calendar', 'icon-calendar-full'] },
    { menuTitle: 'Products', routerLink: '/products', cssClass: ['icon-lms-products', 'icon-lms-products-fill'] },
    { menuTitle: 'Users', routerLink: '/users', cssClass: ['icon-lms-users', 'icon-lms-users_fill'] },
    { menuTitle: 'Book', routerLink: '/book', menuSubTitle: 'Student Book', cssClass: ['icon-book', 'icon-book-full'] },
    { menuTitle: 'Table of Contents', routerLink: '/tableofContents', cssClass: ['icon-bookshelf', 'icon-bookshelf_fill'] },
    { menuTitle: 'Challenge', routerLink: '/challenge', menuIndicator: 'Beta', cssClass: ['icon-challenge', 'icon-challenge-full'] },
    { menuTitle: 'Homework', routerLink: '/homework', cssClass: ['icon-homework', 'icon-homework-full'] },
    { menuTitle: 'Assessments', routerLink: '/assessments', menuIndicator: 'Beta', cssClass: ['icon-lms-assessments', 'icon-assessments-full'] },
    { menuTitle: 'Reports', routerLink: '/reports', cssClass: ['icon-lms-reports', 'icon-lms-reports-fill'] },
    { menuTitle: 'Messages', routerLink: '/messages', menuIndicator: 101, cssClass: ['icon-message-dots-circle', 'icon-message-dots-circle-fill'] },
    { menuTitle: 'Notification', routerLink: '/notification', menuIndicator: 10, isDisable: true, cssClass: ['icon-lms-notification', 'icon-lms-notifications-fill'] },
    { menuTitle: 'My Profile', routerLink: '/profile', cssClass: ['icon-profile', 'icon-profile-full'] },
    { menuTitle: 'Help', routerLink: '/help', cssClass: ['icon-help', 'icon-help-full'] },
    { menuTitle: 'Logout', routerLink: '/logout', cssClass: ['icon-lms-logout', 'icon-lms-logout-fill'] },
    { menuTitle: 'More', routerLink: '/more', cssClass: ['icon-dots-vertical', 'icon-more-full'] }
  ];

  constructor(private activatedRoute: ActivatedRoute, private _router: Router) { }

  ngOnInit() {

    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url.split('?')[0];
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params['isOpened']) {
        this.menuExpandCollapse = (params['isOpened'] == 'true');
      }
      if (params && params['menuExpandCollapse']) {
        if (params['menuExpandCollapse'] == 'true') {
          this.menuExpandCollapse = false;
        } else {
          this.menuExpandCollapse = true;
        }
      }
    });
  }

}